module.exports = __webpack_public_path__ + "img/blue.3e5560e6.png";